import { v4 as uuidv4 } from 'uuid';

import { Menu } from '../../../../vtex-apps/menu/Menu/default';
import { MenuItem } from '../../../../vtex-apps/menu/MenuItem/default';
import { Submenu } from '../../../../vtex-apps/menu/Submenu/default';
import { FlexLayoutCol, FlexLayoutRow } from '../../../../vtex-apps/flex-layout/FlexLayout/default';
import { VisibilityLayout } from '../../../../vtex-apps/VisibilityLayout/default';
import { Image } from '../../../../vtex-apps/store-components/Image/default';

const StoreMenuDesktop = () => {
	return {
		componentName: 'FlexLayoutRow',
		componentGroup: 'StoreMenuDesktop',
		componentId: uuidv4(),
		variables,
		props: FlexLayoutRow({ colSizing: 'equal', blockClass: 'menu-desk-3__row' }).props,
		childrenComponents: [
			FlexLayoutCol({}, [
				Menu({ blockClass: 'menu-desk-3__menu', mzTitle: 'MZ | Menu' }, [
					MenuItem(
						{ id: 'menu-desk-3-1-item', blockClass: 'menu-desk-3__menu-item', mzTitle: 'MZ | Menu Item' },
						[],
						[
							Submenu({ blockClass: 'menu-desk-3__submenu', width: '100%' }, [
								Menu({ orientation: 'vertical', blockClass: 'menu-desk-1__submenu' }, [
									FlexLayoutRow(
										{
											blockClass: 'menu-desk-3__submenu-row',
											colSizing: 'auto',
											experimentalHideEmptyCols: true,
										},
										[
											VisibilityLayout({ title: 'Menu (On/Off)' }, [
												FlexLayoutCol({}, [
													VisibilityLayout({ title: 'Menu Item (On/Off)' }, [
														MenuItem({
															id: 'menu-subitem-3-1',
															blockClass: 'menu-desk-3__submenu-item',
															type: 'category',
														}),
													]),
													VisibilityLayout({ title: 'Menu Item (On/Off)' }, [
														MenuItem({
															id: 'menu-subitem-3-2',
															blockClass: 'menu-desk-3__submenu-item',
															type: 'category',
														}),
													]),
													VisibilityLayout({ title: 'Menu Item (On/Off)' }, [
														MenuItem({
															id: 'menu-subitem-3-3',
															blockClass: 'menu-desk-3__submenu-item',
															type: 'category',
														}),
													]),
													VisibilityLayout({ title: 'Menu Item (On/Off)' }, [
														MenuItem({
															id: 'menu-subitem-3-4',
															blockClass: 'menu-desk-3__submenu-item',
															type: 'category',
														}),
													]),
													VisibilityLayout({ title: 'Menu Item (On/Off)' }, [
														MenuItem({
															id: 'menu-subitem-3-5',
															blockClass: 'menu-desk-3__submenu-item',
															type: 'category',
														}),
													]),
													VisibilityLayout({ title: 'Menu Item (On/Off)' }, [
														MenuItem({
															id: 'menu-subitem-3-6',
															blockClass: 'menu-desk-3__submenu-item',
															type: 'category',
														}),
													]),
												]),
											]),
											VisibilityLayout({ title: 'Menu (On/Off)' }, [
												FlexLayoutCol({}, [
													VisibilityLayout({ title: 'Menu Item (On/Off)' }, [
														MenuItem({
															id: 'menu-subitem-3-1',
															blockClass: 'menu-desk-3__submenu-item',
															type: 'category',
														}),
													]),
													VisibilityLayout({ title: 'Menu Item (On/Off)' }, [
														MenuItem({
															id: 'menu-subitem-3-2',
															blockClass: 'menu-desk-3__submenu-item',
															type: 'category',
														}),
													]),
													VisibilityLayout({ title: 'Menu Item (On/Off)' }, [
														MenuItem({
															id: 'menu-subitem-3-3',
															blockClass: 'menu-desk-3__submenu-item',
															type: 'category',
														}),
													]),
													VisibilityLayout({ title: 'Menu Item (On/Off)' }, [
														MenuItem({
															id: 'menu-subitem-3-4',
															blockClass: 'menu-desk-3__submenu-item',
															type: 'category',
														}),
													]),
													VisibilityLayout({ title: 'Menu Item (On/Off)' }, [
														MenuItem({
															id: 'menu-subitem-3-5',
															blockClass: 'menu-desk-3__submenu-item',
															type: 'category',
														}),
													]),
													VisibilityLayout({ title: 'Menu Item (On/Off)' }, [
														MenuItem({
															id: 'menu-subitem-3-5',
															blockClass: 'menu-desk-3__submenu-item',
															type: 'category',
														}),
													]),
												]),
											]),
											VisibilityLayout({ title: 'Menu (On/Off)' }, [
												FlexLayoutCol({}, [
													Image({
														blockClass: 'menu-subitem-3-img',
														title: 'MZ | Menu Banner',
														src: 'https://hefesto-upload-images.s3.amazonaws.com/1675112277016-250x350.png',
													}),
												]),
											]),
											VisibilityLayout({ title: 'Menu (On/Off)' }, [
												FlexLayoutCol({}, [
													Image({
														blockClass: 'menu-desk-3__submenu-img',
														title: 'MZ | Menu Banner',
														src: 'https://hefesto-upload-images.s3.amazonaws.com/1675112277016-250x350.png',
													}),
												]),
											]),
										],
									),
								]),
							]),
						],
					),
					MenuItem({
						id: 'menu-desk-3-1-item',
						blockClass: 'menu-desk-3__menu-item',
						mzTitle: 'MZ | Menu Item',
					}),
					MenuItem({
						id: 'menu-desk-3-1-item',
						blockClass: 'menu-desk-3__menu-item',
						mzTitle: 'MZ | Menu Item',
					}),
					MenuItem({
						id: 'menu-desk-3-1-item',
						blockClass: 'menu-desk-3__menu-item',
						mzTitle: 'MZ | Menu Item',
					}),
					MenuItem({
						id: 'menu-desk-3-1-item',
						blockClass: 'menu-desk-3__menu-item',
						mzTitle: 'MZ | Menu Item',
					}),
					MenuItem({
						id: 'menu-desk-3-1-item',
						blockClass: 'menu-desk-3__menu-item',
						mzTitle: 'MZ | Menu Item',
					}),
					MenuItem({
						id: 'menu-desk-3-1-item',
						blockClass: 'menu-desk-3__menu-item',
						mzTitle: 'MZ | Menu Item',
					}),
				]),
			]),
		],
	};
};

const variables = [
	{
		type: 'color',
		list: [
			{ from: '--white', to: '--menu-desktop-3-menu-bg-color', name: 'Menu Background' },
			//text hover color
			{ from: '--text-color-1-light', to: '--menu-desktop-3-menu-text-hover-color', name: 'Menu Text Hover' },

			{ from: '--text-color-1-dark', to: '--menu-desktop-3-menu-text-color', name: 'Menu Text' },
			//submenu text color
			{ from: '--text-color-1-dark', to: '--menu-desktop-3-submenu-text-color', name: 'Submenu Text' },
			//submenu
			{ from: '--white', to: '--menu-desktop-3-submenu-bg-color', name: 'Submenu' },
			//submenu border color
			{ from: '--text-color-1-dark', to: '--menu-desktop-3-submenu-border-color', name: 'Submenu Border' },
			//submenu item hover
			{
				from: '--neutral-color-high-medium',
				to: '--menu-desktop-3-submenu-item-hover-color',
				name: 'Submenu Item Hover',
			},
		],
	},
	{
		type: 'borderRadius',
		list: [
			{ from: '--border-radius-none', to: '--menu-desktop-3-border-radius', name: 'Border Radius' },
			{ from: '--border-radius-sm', to: '--menu-desktop-3-submenu-br', name: 'Submenu' },
		],
	},
	{
		type: 'fontSize',
		list: [
			{ from: '--font-size-xs', to: '--menu-desktop-3-main-size', name: 'Main font Size' },
			//submenu text size
			{ from: '--font-size-xs', to: '--menu-desktop-3-submenu-fs', name: 'Submenu' },
		],
	},
	{
		type: 'fontWeight',
		list: [
			{ from: '--font-weight-400', to: '--menu-desktop-3-menu-weight', name: 'Menu font weight' },
			//submenu
			{ from: '--font-weight-400', to: '--menu-desktop-3-submenu-fw', name: 'Submenu' },
		],
	},
	{
		type: 'spacing',
		list: [
			//menu height
			{ from: '--spacing-nano', to: '--menu-desktop-3-menu-height', name: 'Menu Height' },
			{ from: '--spacing-atom', to: '--menu-desktop-3-submenu-gap', name: 'Submenu Items Gap' },
			//submenu lateral padding
			{ from: '--spacing-sm', to: '--menu-desktop-3-submenu-lateral-padding', name: 'Submenu Lateral Padding' },
		],
	},
];

export default StoreMenuDesktop;
